export default {
  // START:: GET APP THEME
  getAppTheme(state) {
    return state.perfermo_provider_dashboard_theme;
  },
  // END:: GET APP THEME GETTER
};
